<template>
  <div class="second_item" @click="openQA()">
    <div class="second_item_Q">
      <span>{{sortI+1}}</span>
      <span>{{data.Q}}</span>
    </div>
    <div class="second_item_A" v-if="QAState">
      {{data.A}}
    </div>
    <div class="second_item_open">
      <img src="../../assets/imgs/select_black.png" />
    </div>
  </div>
</template>

<script>

export default {
  props:{
    data:{
      type:Object,
      default: null
    },
    sortI:{
      type: Number,
      default: 1
    }
  },
  components: {
  },
  data () {
    return{
      QAState : false
    }
  },
  created () {
  },
  methods: {
    openQA(){
      if(this.QAState){
        this.QAState = false
      }else{
        this.QAState = true
      }
    }
  }
}
</script>
<style scoped>
  .second_item{
    padding: 27px 30px 27px 25px;
    margin: 0 auto;
    margin-top: 25px;
    width: 767px;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
  }
  .second_item:first-child{
    margin-top: 47px;
  }
  .second_item_Q{
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
  }
  .second_item_Q span:first-child{
    margin-right: 12px;
  }
  .second_item_A{
    width: 728px;
    margin: 0 auto;
    margin-top: 15px;
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
  }
  .second_item_open{
    width: 11px;
    height: 7;
    position: absolute;
    top: 31px;
    right: 30px;
  }
  .second_item_open img{
    width: 11px;
    height: 7;
  }
</style>